import { ApiResponse, RequestFailure } from '@owl-nest/api-client'
import * as api from '@owl-nest/api-client/latest'
import { PromiseAction } from '@owl-nest/redux-wrapper'
import { RootState } from '../reducers'

export enum ACTION_TYPE {
  LOAD_FAQ_REQUEST = 'LOAD_FAQ_REQUEST',
  LOAD_FAQ_SUCCESS = 'LOAD_FAQ_SUCCESS',
  LOAD_FAQ_FAILURE = 'LOAD_FAQ_FAILURE',
  CREATE_FAQ_REQUEST = 'CREATE_FAQ_REQUEST',
  CREATE_FAQ_SUCCESS = 'CREATE_FAQ_SUCCESS',
  CREATE_FAQ_FAILURE = 'CREATE_FAQ_FAILURE',
}

type LoadFaqFailure = { type: ACTION_TYPE.LOAD_FAQ_FAILURE; failure: RequestFailure }
type LoadFaqRequest = { type: ACTION_TYPE.LOAD_FAQ_REQUEST }
type LoadFaqSuccess = {
  type: ACTION_TYPE.LOAD_FAQ_SUCCESS
  success: api.Pageable<api.FaqList> & { forceClean: boolean }
}

type LoadConfig = { pagination?: string; forceClean?: boolean }

export function loadProjectFaq(
  projectId: number,
  { pagination = undefined, forceClean = false }: LoadConfig = {},
  projectToken?: string,
): PromiseAction<RootState, ApiResponse<api.Pageable<api.FaqList> & { forceClean: boolean }>> {
  return {
    types: [ACTION_TYPE.LOAD_FAQ_REQUEST, ACTION_TYPE.LOAD_FAQ_SUCCESS, ACTION_TYPE.LOAD_FAQ_FAILURE],
    promise: async (_, state) => {
      const getParams = new URLSearchParams(pagination)
      if (projectToken !== undefined) {
        getParams.set('token', projectToken)
      }

      const response = await api.api.get.projectFaq({
        urlParams: { projectId: projectId.toString() },
        getParams,
        withToken: state.user.identity.type === 'loggedin',
      })

      return response.next(success => ({ ...success.body, forceClean }))
    },
  }
}

type CreateFaqProjectFailure = {
  type: ACTION_TYPE.CREATE_FAQ_FAILURE
  failure: RequestFailure
}
type CreateFaqProjectRequest = { type: ACTION_TYPE.CREATE_FAQ_REQUEST }
type CreateFaqProjectSuccess = { type: ACTION_TYPE.CREATE_FAQ_SUCCESS; success: api.I18n }

export const createFaq = (projectId: number, question: string, lang: api.Lang): any => ({
  types: [ACTION_TYPE.CREATE_FAQ_REQUEST, ACTION_TYPE.CREATE_FAQ_SUCCESS, ACTION_TYPE.CREATE_FAQ_FAILURE],
  async promise() {
    const questionI18n: api.I18n = {}
    questionI18n[lang] = question
    return await api.api.post.projectFaq({
      urlParams: { projectId: projectId.toString() },
      body: { question: questionI18n },
    })
  },
})

export type FaqAction =
  | LoadFaqRequest
  | LoadFaqSuccess
  | LoadFaqFailure
  | CreateFaqProjectRequest
  | CreateFaqProjectSuccess
  | CreateFaqProjectFailure
